import * as React from 'react';
import "./message.scss";
export default class LicExp extends React.Component<{}>{
    public render() {
        return (


            
            <div id="dvlicExpireMessage" className="mesagecontainer">
                <p className="licheading">MIPA license period has expired.</p>
                <p>
                    We hope you've had an opportunity to explore the features and 
                    functionality of MIPA. Your trial has expired. You can continue 
                    providing these services to your organization by purchasing a 
                    subscription today. Are you ready to convert your trial to a 
                    paid subscription? It is a subscription-based license.
                </p>
                <p>
                    <ol>
                    <li><b>Starter pack</b>  of 5 users. (5 x 4 x 12 month = 240,- )
                         <b> This is our minimum order</b></li>
                         <li>Up to 50 users, US $4,- or Euro 4,- per user per month based on a yearly subscription and <b>a minimum of 5 user per order</b>.</li>
                        <li>From 50 users, US $3,- or Euro 3,- per user per month based on a yearly subscription.</li>
                        <li>Over 500, get a quote</li>
                        <li>Legal information regarding MIPA - MIPA license agreement</li>
                    </ol>
                </p>

                <p>
                    <span data-html="licexpoirepara3">Send an email to</span>{' '}  
                    <a href="mailto:aek@iglobe.dk" target="_blank">aek@iglobe.dk</a>  with
                    <ol>
                        <li data-html="licexpoirepara4">The required number of users</li>
                        <li data-html="licexpoirepara5">
                        Invoicing information, contact name and email, company name, 
                        address, postal code, city, country if possible vat number. 
                        you will receive a paypal invoice that you can pay using your 
                        credit card.</li>
                    </ol>
                </p>
                <p data-html="licexpoirepara6">
                We will activate your account immediately when we received the order 
                from you, making it possible for your organization to continue using 
                the Add-in.</p>

                <p data-html="licexpoirepara7">Thank you for using iGlobe MIPA. 
                We hope you had the opportunity to experience all some of the other Apps 
                and Add-ins that iGlobe has to offer. We look forward to continuing to 
                provide services for your business.</p>

                <p data-html="sincerely"> Sincerely</p>
                <p>
                    Alon Ekelund<br />CEO<br />iGlobe
                </p>

                <p>Should you have any questions please feel free to <a href="mailto:sales@iglobe.dk" target="_blank" rel="noopener">contact us</a>. We can also offer you a demo or assist you in the implementation. As it is a simple product, we believe it will not take more than just 30 min. <a href="https://outlook.office365.com/owa/calendar/iGlobeOffice365@iglobe.dk/bookings/" target="_blank" rel="noopener">Book us now</a></p>
            </div>
        );
    }
}